// This exists so that it can be used in the legacy build/publish frontend.
export enum BuilderTemplateType {
    email = 'email',
    image = 'image',
    print = 'print',
    video = 'video'
}
